import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=324adb91"
import script from "./navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./navbar.vue?vue&type=style&index=0&id=324adb91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports